module.exports = __webpack_public_path__ + "static/media/Chrono.36e9f6b5.svg";


//////////////////
// WEBPACK FOOTER
// ./src/resources/img/Chrono.svg
// module id = 244
// module chunks = 8